import AnnotationIcon from './AnnotationIcon';
export default AnnotationIcon;
